/**
 * The categorical order the charts draw from.
 *
 * Its own module rather than a constant beside the components, because a file
 * that exports both components and values breaks Vite's fast refresh — and
 * because these are consumed by cards that draw no chart at all (the legend
 * swatches beside a bar list, for one).
 *
 * The hex values live in `analytics.css` as `--viz-*`, validated as a palette
 * for both themes; see the header comment there for why the console's existing
 * channel hues could not be reused.
 */

/**
 * Assigned in FIXED ORDER and never cycled: a dimension keeps its colour when a
 * filter removes the series above it, and a seventh series folds into
 * `--viz-other` rather than being handed a generated hue.
 */
export const SERIES = [
  'var(--viz-1)',
  'var(--viz-2)',
  'var(--viz-3)',
  'var(--viz-4)',
  'var(--viz-5)',
  'var(--viz-6)',
];

export const OTHER = 'var(--viz-other)';

export const seriesColor = (index: number): string => SERIES[index] ?? OTHER;

/**
 * A donut compares every slice with every other, not just its neighbours, and
 * only the first five clear the separation bar in dark mode — so it stops at
 * five and folds the remainder into one `(other)` slice.
 */
export const DONUT_SLOTS = 5;
